import { render, staticRenderFns } from "./Sixth.vue?vue&type=template&id=3038e362&"
import script from "./Sixth.vue?vue&type=script&lang=ts&"
export * from "./Sixth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports